export default __webpack_public_path__ + "static/media/visa.c59f0685.jpg";